
import { styled } from "@mui/system";
import { TextField, FormControl, FormLabel } from "@mui/material";

// New component with separate label
const StyledFormControl = styled(FormControl)({
    marginTop: "8px",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#F8F8F8",
      },
      "&:hover fieldset": {
        borderColor: "#F8F8F8",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#F8F8F8",
      },
      borderRadius: "4px",
    },
    "& .MuiTextField-root": {
      marginTop: "0px",
    },
    "& .MuiInputBase-input": {
      "&.Mui-disabled": {
        color: "#b9b9b9",
        "-webkit-text-fill-color": "#b9b9b9",
      },
      marginTop: "0px",                   
      padding: "12px 16px",
      height: "18px",
      lineHeight: "18px",
      backgroundColor: "#1F2735",

      "&:-webkit-autofill": {
        backgroundColor: "#1F2735 !important",
      },
      "&:-internal-autofill-selected": {
        backgroundColor: "#1F2735 !important",
      },
      "&::placeholder": {
        fontStyle: "italic",
        color: "#A1A5AC",
        fontWeight: "400",
        lineHeight: "18px",
        fontSize: "14px",
      },
    },
    "& .MuiFormLabel-root": {
      color: "#ffffff",
      marginBottom: "8px",
      fontWeight: "500",
      fontStyle: "bold",
      fontSize: "14px",
      lineHeight: "18px",
    },

    "& .MuiFormHelperText-root": {
      fontWeight: 500,
      marginLeft: "0px",
      fontSize: "12px", 
      lineHeight: "16px",
    },
  });
  
  // Usage example component
  const StyledTextFieldGroup = ({ label, subLabel, ...textFieldProps }) => {
    return (
      <StyledFormControl fullWidth margin="normal">
        <FormLabel>{label}</FormLabel>
        {subLabel && <FormLabel sx={{ 
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "140%",
            letterSpacing: "1%",
          }}>
            {subLabel}
          </FormLabel>
        }
        <TextField
          variant="outlined"
          {...textFieldProps}
        />
      </StyledFormControl>
    );
  };
  
  export { StyledTextFieldGroup };